<template>
  <div class="featured-article pb-4">
    <div class="card card-scroll box-shadow grid grid-cols-1 md:grid-cols-2 items-center">
      <div class="">
        <div class="automation-news-article-image relative">
          <img class="img-fluid article-image ls-is-cached lazyload" :data-src="article.img_main" :alt="article.article_title" width="680" height="384" data-lazy="Article - Image - Main - Placeholder">
        </div>
      </div>
      <div class="d-flex flex-column article-info-container">
        <div class="article-info flex items-center mb-3">
          <div class="article-author flex items-center">
            <div class="author-img">
              <img class="ls-is-cached lazyload" :data-src="article.author.author_image" width="30" height="30" >
            </div>
            <div class="author-name pl-2">
              <a :href="article.author.path" v-if="article.author.path">
                {{article.author.display_name}}
              </a>

              <span v-else>
                {{article.author.display_name}}
              </span>
            </div>
          </div>
          <div class="article-reading-time pl-4">
            {{article.read_time}} {{article.read_time_label}}
          </div>
        </div>
        <div class="article-title">
          <a :href="article.path" class="mb-1">
            {{article.article_title}}
          </a>
        </div>
        <div class="article-short-description">
          {{article.short_description}}
        </div>
        <div class="article-footer row">
          <div class="col-12 footer-item publish-date">
            {{article.time_ago}}
            <span class="" v-if="article.country_name">| {{article.country_name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article-featured',
  props: {
    article: {
      required: true,
    },
  },
  mounted() {},
};
</script>
